export class Grouping {
  id: number;
  groupingName: string;
  metadataStructureName: string;
  domain: Array<string>;
}
